import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { candidatesSelect } from '@collections/candidates';

@Injectable()
export class CandidateDetailsSelectResolver {
  constructor(private store: Store<{}>) {}

  resolve(route: ActivatedRouteSnapshot): Observable<void> | void {
    this.store.dispatch(candidatesSelect({ id: route.params.id }));
  }
}
